<template type="pug">
    <canvas ref="canvas"></canvas>
</template>

<script>
import Chart from 'chart.js';

export default {
    name: 'chart',
    props: ['type', 'labels', 'data', 'backgroundColor'],
    mounted() {
        this.chart = new Chart(this.$refs.canvas, {
            type: this.type,
            data: {
                labels: this.labels,
                datasets: [{
                    data: this.data,
                    backgroundColor: this.backgroundColor,
                }]
            },
            options: { legend: { position: 'right' } },
        });
    },
    unmounted() {
        this.chart.destroy();
    }
}
</script>